module.exports = __webpack_public_path__ + "img/logo.75b157e0.png";